import { render } from "./UploadCategory.vue?vue&type=template&id=6f221208&scoped=true"
import script from "./UploadCategory.vue?vue&type=script&lang=js"
export * from "./UploadCategory.vue?vue&type=script&lang=js"

import "./UploadCategory.vue?vue&type=style&index=0&id=6f221208&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f221208"]])

export default __exports__